import {Component, OnInit} from '@angular/core';
import {NgbDateStruct, NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';
import {Observable, Subject} from 'rxjs';
import {MerlinxService} from '../../../shared/services/merlinx.service';
import {Params, Router} from '@angular/router';
import {MerlinxParkingEntry} from '../../../shared/interfaces/merlinx-parking-entry';
import {debounceTime, distinctUntilChanged, switchMap, tap} from 'rxjs/operators';

@Component({
  selector: 'app-engine-merlinx-parkings',
  templateUrl: './engine-merlinx-parkings.component.html',
  styleUrls: ['./engine-merlinx-parkings.component.scss']
})
export class EngineMerlinxParkingsComponent implements OnInit {

  constructor(private mxs: MerlinxService,
              private router: Router) { }

  isLoading: boolean;
  locations$: Observable<MerlinxParkingEntry[]>;
  locationQuery$ = new Subject<string>();

  times: NgbTimeStruct[];
  selectedLocation: MerlinxParkingEntry;
  selectedCheckinDate: NgbDateStruct;
  selectedCheckinTime: NgbTimeStruct;
  selectedCheckoutDate: NgbDateStruct;
  selectedCheckoutTime: NgbTimeStruct;

  ngOnInit(): void {
    this.populateTimes();
    this.locations$ = this.locationQuery$.pipe(
      distinctUntilChanged(),
      tap(() => this.isLoading = true),
      debounceTime(200),
      switchMap(e => this.mxs.parkingQuery(e)),
      tap(() => this.isLoading = false)
    );
  }

  populateTimes(): void {
    const ret: NgbTimeStruct[] = [];
    const hours = 24;
    const minutes = [0, 15, 30, 45];
    for (let i = 0; i < hours; i++) {
      minutes.forEach(e => {
        const time = {hour: i, minute: e, second: 0};
        if (time.hour === 10 && time.minute === 0) {
          this.selectedCheckinTime = time;
          this.selectedCheckoutTime = time;
        }
        ret.push(time);
      });
    }
    this.times = ret;
  }

  getParkingItemName(input: MerlinxParkingEntry): string {
    return `${input.name}`;
  }

  getTimeItemName(input: NgbTimeStruct): string {
    let ret = '';
    if (input.hour < 10) {
      ret += '0';
    }
    ret += input.hour;
    ret += ':';
    if (input.minute < 10) {
      ret += '0';
    }
    ret += input.minute;
    return ret;
  }

  convertDateFromNgb(input: NgbDateStruct): string {
    return dayjs(`${input.day}-${input.month}-${input.year}`, 'D-M-YYYY').format('DD.MM.YYYY');
  }

  convertTimeFromNgb(input: NgbTimeStruct): string {
    return this.getTimeItemName(input).replace(':', '');
  }

  doSearch(): void {
    const codePlace = this.selectedLocation.code;
    const depDate = this.convertDateFromNgb(this.selectedCheckinDate);
    const retDate = this.convertDateFromNgb(this.selectedCheckoutDate);
    const departureTime = this.convertTimeFromNgb(this.selectedCheckinTime);
    const returnTime = this.convertTimeFromNgb(this.selectedCheckoutTime);

    const queryParams: Params = {};

    const url = 'm/parcheggio';
    queryParams.transport = 'multi';
    queryParams.depp = codePlace;
    queryParams.depdp = depDate;
    queryParams.dtp = departureTime;
    queryParams.retdp = retDate;
    queryParams.rdtp = returnTime;

    this.router.navigate([url], {queryParams});
  }

}
